module.exports = __webpack_public_path__ + "static/inside-jaccuzzi-7fca543d07453344c0e4fb0e5303f2ed.jpg";